module.exports = __webpack_public_path__ + "static/media/short-term.7554f7cc.svg";